import React, { useState } from 'react';
import { UserIcon, MailIcon, TrendingUpIcon, DollarSignIcon, PackageIcon, MessageSquareIcon } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    ingresosAnuales: '',
    cantidadRequerida: '',
    tipoBien: '',
    comentarios: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="py-20 bg-[#1A1A1A]" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="mb-12" data-id="element-58">
          <h2 className="text-4xl font-light text-white mb-4" data-id="element-59">Contáctanos</h2>
          <p className="text-xl text-gray-400" data-id="element-60">
            Para poder realizar un arrendamiento requieres:
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-61">
          {/* Form Section */}
          <div className="lg:col-span-2" data-id="element-62">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-63">
              {/* Name and Email Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-64">
                <div data-id="element-65">
                  <label htmlFor="nombre" className="block text-gray-400 mb-2 text-sm" data-id="element-66">
                    Nombre
                  </label>
                  <div className="relative" data-id="element-67">
                    <input type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} className="w-full bg-[#2D2D2D] text-white px-4 py-3 pr-12 rounded focus:outline-none focus:ring-2 focus:ring-[#2BA6DE]" required data-id="element-68" />
                    <UserIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} data-id="element-69" />
                  </div>
                </div>

                <div data-id="element-70">
                  <label htmlFor="email" className="block text-gray-400 mb-2 text-sm" data-id="element-71">
                    E-mail
                  </label>
                  <div className="relative" data-id="element-72">
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full bg-[#2D2D2D] text-white px-4 py-3 pr-12 rounded focus:outline-none focus:ring-2 focus:ring-[#2BA6DE]" required data-id="element-73" />
                    <MailIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} data-id="element-74" />
                  </div>
                </div>
              </div>

              {/* Annual Income and Required Amount Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-75">
                <div data-id="element-76">
                  <label htmlFor="ingresosAnuales" className="block text-gray-400 mb-2 text-sm" data-id="element-77">
                    Ingresos Anuales
                  </label>
                  <div className="relative" data-id="element-78">
                    <input type="text" id="ingresosAnuales" name="ingresosAnuales" value={formData.ingresosAnuales} onChange={handleChange} className="w-full bg-[#2D2D2D] text-white px-4 py-3 pr-12 rounded focus:outline-none focus:ring-2 focus:ring-[#2BA6DE]" required data-id="element-79" />
                    <TrendingUpIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} data-id="element-80" />
                  </div>
                </div>

                <div data-id="element-81">
                  <label htmlFor="cantidadRequerida" className="block text-gray-400 mb-2 text-sm" data-id="element-82">
                    Cantidad Requerida
                  </label>
                  <div className="relative" data-id="element-83">
                    <input type="text" id="cantidadRequerida" name="cantidadRequerida" value={formData.cantidadRequerida} onChange={handleChange} className="w-full bg-[#2D2D2D] text-white px-4 py-3 pr-12 rounded focus:outline-none focus:ring-2 focus:ring-[#2BA6DE]" required data-id="element-84" />
                    <DollarSignIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} data-id="element-85" />
                  </div>
                </div>
              </div>

              {/* Asset Type */}
              <div data-id="element-86">
                <label htmlFor="tipoBien" className="block text-gray-400 mb-2 text-sm" data-id="element-87">
                  Tipo de bien a arrendar
                </label>
                <div className="relative" data-id="element-88">
                  <select id="tipoBien" name="tipoBien" value={formData.tipoBien} onChange={handleChange} className="w-full bg-[#2D2D2D] text-white px-4 py-3 pr-12 rounded focus:outline-none focus:ring-2 focus:ring-[#2BA6DE] appearance-none" required data-id="element-89">
                    <option value="" data-id="element-90">Selecciona una opción</option>
                    <option value="transporte" data-id="element-91">Equipos de Transporte</option>
                    <option value="maquinaria" data-id="element-92">
                      Maquinaria y Equipo Industrial
                    </option>
                    <option value="mobiliario" data-id="element-93">
                      Mobiliario y Equipo de Oficina
                    </option>
                    <option value="computo" data-id="element-94">
                      Equipo de Cómputo y Electrónico
                    </option>
                  </select>
                  <PackageIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" size={20} data-id="element-95" />
                </div>
              </div>

              {/* Comments */}
              <div data-id="element-96">
                <label htmlFor="comentarios" className="block text-gray-400 mb-2 text-sm" data-id="element-97">
                  Comentarios
                </label>
                <div className="relative" data-id="element-98">
                  <textarea id="comentarios" name="comentarios" value={formData.comentarios} onChange={handleChange} rows={6} className="w-full bg-[#2D2D2D] text-white px-4 py-3 pr-12 rounded focus:outline-none focus:ring-2 focus:ring-[#2BA6DE] resize-none" data-id="element-99" />
                  <MessageSquareIcon className="absolute right-4 top-4 text-gray-500" size={20} data-id="element-100" />
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" className="bg-[#2BA6DE] text-white px-8 py-3 rounded font-medium hover:bg-[#2495c8] transition-colors" data-id="element-101">
                ENVIAR MENSAJE
              </button>
            </form>
          </div>

          {/* Company Information */}
          <div className="lg:col-span-1" data-id="element-102">
            <div className="bg-[#2D2D2D] rounded-lg p-8" data-id="element-103">
              <h3 className="text-2xl font-light text-white mb-8" data-id="element-104">
                Información de Empresa
              </h3>

              <div className="space-y-6" data-id="element-105">
                <div data-id="element-106">
                  <h4 className="text-lg font-semibold text-gray-300 mb-2" data-id="element-107">
                    ArrendaLogic
                  </h4>
                </div>

                <div data-id="element-108">
                  <p className="text-gray-400 text-sm mb-1" data-id="element-109">Teléfono:</p>
                  <a href="tel:+5218183628763" className="text-white hover:text-[#2BA6DE] transition-colors" data-id="element-110">
                    +52 1 (818) 362-8763
                  </a>
                </div>

                <div data-id="element-111">
                  <p className="text-gray-400 text-sm mb-1" data-id="element-112">E-mail:</p>
                  <a href="mailto:info@arrendalogic.com" className="text-white hover:text-[#2BA6DE] transition-colors" data-id="element-113">
                    info@arrendalogic.com
                  </a>
                </div>

                <div data-id="element-114">
                  <p className="text-gray-400 text-sm mb-1" data-id="element-115">Sitio Web:</p>
                  <a href="https://www.arrendalogic.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#2BA6DE] transition-colors" data-id="element-116">
                    www.arrendalogic.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}